import isSupported from './services/isSupported';
import loadScript from './services/loadScript';

export { default as isIOS } from './services/isIOS';
export { default as isSafariLowerThan13 } from './services/isSafari';

const isBrowser = () =>
  !(navigator.userAgent.includes('Node.js') || navigator.userAgent.includes('jsdom'));

export default {
  loadScript,
  isBrowser,
  isSupported,
  window: typeof window !== 'undefined' ? window : undefined,
  document: typeof window !== 'undefined' ? window.document : undefined,
};
